export class WebFragmentError extends Error {}
